import { render, staticRenderFns } from "./GoodAudience.vue?vue&type=template&id=8b6c78d2&scoped=true"
import script from "./GoodAudience.vue?vue&type=script&lang=js"
export * from "./GoodAudience.vue?vue&type=script&lang=js"
import style0 from "./GoodAudience.vue?vue&type=style&index=0&id=8b6c78d2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b6c78d2",
  null
  
)

export default component.exports